import axios from 'axios'
import { AggregatedPartnerNewRequest } from '../../interfaces/partner/AggregatedPartnerNew'

export const aggregatedRegisterPartner = async (partnerData: AggregatedPartnerNewRequest) => {
  const response = await axios.post('/data/izveidot_sadarbības_partneri', partnerData)

  return response.data
}
